import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { cancelOrder } from '../../services/orders/orders';


const useStyles = theme => ({
    iconView: {
        color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200
        }
    },
    dialog: {
        '& .MuiPaper-root': {
            margin: theme.spacing(1),
            width: 250,
            height: 200
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    red: {
        '& label.Mui-focused': {
            color: 'red'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'red',
        }
    }
});

class CancelOrder extends Component {
    constructor(props) {
        super(props);
        this.cancelOrder = this.cancelOrder.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            order: {},
            waiting: false
        }
    }

    cancelOrder = () => {

        cancelOrder(this.props.lockerId, this.props.order.id, (data) => {

            this.setState({ order: {}, waiting: false });
            this.props.onChange(false);
            (data) ? this.props.setNotification("Encomenda cancelado com sucesso!", "success") : this.props.setNotification("Encomenda não foi cancelada!", "danger");
        });

    }

    handleCancel = () => {
        this.setState({ waiting: true });
        this.cancelOrder();
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{(this.state.waiting) ? "Cancelando Encomenda" : "Cancelar Encomanda"}</DialogTitle>
                    <DialogContent>
                        {(this.state.waiting) ? <div><Circular /></div> :
                            <form className={classes.root} noValidate autoComplete="off">
                                <div>
                                    <TextField className={classes.green}
                                        label="Porta"
                                        value={(this.props.order.slotName) ? this.props.order.slotName : this.props.order.slotId}
                                        disabled
                                    >
                                    </TextField>
                                    <TextField className={classes.green}
                                        label="Encomenda ID"
                                        value={this.props.order.id}
                                        disabled
                                    >
                                    </TextField>
                                    <TextField className={classes.green}
                                        label="Status"
                                        value={this.props.order.status}
                                        disabled
                                    >
                                    </TextField>
                                    <TextField className={classes.green}
                                        label="Tamanho"
                                        value={this.props.order.size}
                                        disabled
                                    >
                                    </TextField>
                                    <TextField className={classes.green}
                                        label="Código da encomenda"
                                        value={this.props.order.deliveryToken}
                                        disabled
                                    >
                                        {/* </TextField>  
                            <TextField className={ classes.green}
                            label="AWB"
                            value={this.props.order.AWB}
                            disabled
                            > */}
                                    </TextField>
                                    <TextField className={classes.green}
                                        label="Tranportadora"
                                        value={this.props.order.carrier}
                                        disabled
                                    >
                                    </TextField>
                                    <TextField className={classes.green}
                                        label="Celular"
                                        value={this.props.order.mobile_phone}
                                        disabled
                                    >
                                    </TextField>
                                </div>
                            </form>}
                    </DialogContent>
                    <DialogActions>
                        {(this.state.waiting) ? null :
                            <div><Button onClick={this.handleClose} color="default">
                                Voltar
                    </Button>
                                <Button onClick={this.handleCancel} color="danger" autoFocus>
                                    Cancelar
                    </Button></div>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(CancelOrder);